import React from "react";
import { THEME_COLORS } from "../themes/DarkLight";
import useThemeHook from "../hooks/useThemeHook";

type Props = {};

export default function PageView({ children }: { children: any }) {
  const theme = useThemeHook();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        overflowY: "scroll",
        paddingBottom: "20px",
        backgroundColor: THEME_COLORS[theme].page_background_color,
        width: "100%",
        paddingLeft: "13px",
        paddingRight: "13px",
      }}
    >
      {children}
      <div style={{ minHeight: "50px" }}></div>
    </div>
  );
}
